import React, {useEffect, useState} from "react";
import {DriverTimeSheet, TimeSheet} from "../types";
import {getTimesheets, getDriverTimesheets} from "../api/dataService";
import NavigationCard from "./NavigationCard";
import {Stack} from "react-bootstrap";
import {getTimesheetDict, getDateString} from "../util/Helpers";
import {Navigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {RootState} from "../redux/reduxTypes";


const WeekTimesheets: React.FC = () => {

    const pastDayInterval = 7
    const user = useSelector((state: RootState) => state.user)
    const filters = ['Ownership_Group', 'Management', 'Office_Admin', 'Supervisor'].some((role) =>
        (user.groups as string []).includes(role)) ? '':`?employee=${user.userid}`
    const [timesheetData, setTimesheetData] = useState<(TimeSheet | DriverTimeSheet)[]>([])
    useEffect(() => {
        Promise.all([getTimesheets(undefined, filters), getDriverTimesheets(undefined, filters)])
            .then(([timesheetResponse, driverTimesheetResponse]) => {
                let allTimesheets: (TimeSheet | DriverTimeSheet)[] = [];

                if('redirectTo' in timesheetResponse) {
                    return <Navigate to={timesheetResponse.redirectTo}/>
                }
                if(Array.isArray(timesheetResponse)) {
                    allTimesheets = [...allTimesheets, ...timesheetResponse];
                }

                if('redirectTo' in driverTimesheetResponse) {
                    return <Navigate to={driverTimesheetResponse.redirectTo}/>
                }
                if(Array.isArray(driverTimesheetResponse)) {
                    allTimesheets = [...allTimesheets, ...driverTimesheetResponse];
                }

                // Filter out timesheets with status "deleted"
                const filteredTimesheets = allTimesheets.filter(entry => entry.status !== 'deleted');
                setTimesheetData(filteredTimesheets);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    }, [user]);


    const timesheetsByDay = getTimesheetDict(new Date(),pastDayInterval)

    timesheetData.forEach((value:TimeSheet,index:number) => {
        const dayKey = getDateString(value.start_date);

        if(timesheetsByDay[dayKey]){
            timesheetsByDay[dayKey].push(value)
        }

    })

    return (
        <Stack>
            {Object.keys(timesheetsByDay).length === 0 ? (
                <div>No Timesheet Entries</div>
            ) : (
                Object.entries(timesheetsByDay).map(([dayKey, timesheets], index) => {
                    // Count driver time sheets
                    const driverTimesheets = timesheets.filter(sheet => 'vehicle' in sheet);
                    const hasDriverTimesheets = driverTimesheets.length > 0;

                    // Create subtitle with driver timesheet info if available
                    let subtitle = `${timesheets.length} recorded time entries`;
                    if (hasDriverTimesheets) {
                        subtitle += ` (${driverTimesheets.length} driver entries)`;
                    }

                    // Create body with driver info if available
                    let body = "";
                    if (hasDriverTimesheets) {
                        const vehicleNames = driverTimesheets
                            .map(sheet => (sheet as DriverTimeSheet).vehicle?.make + ' ' + (sheet as DriverTimeSheet).vehicle?.model)
                            .filter(Boolean);

                        // Use Array.from instead of spread operator for Set
                        const vehicles = Array.from(new Set(vehicleNames));

                        if (vehicles.length > 0) {
                            body = `Vehicles: ${vehicles.join(', ')}`;
                        }
                    }

                    return (
                        <NavigationCard
                            title={`${dayKey}`}
                            subtitle={subtitle}
                            body={body}
                            subtext=""
                            link_destination={`/timesheets/${index}`}
                            link_state={timesheets}
                            id={""} // Use entryIndex as the key if no unique ID is available
                            key={index}
                        />
                    );
                })
            )}
        </Stack>
    );
}

export default WeekTimesheets
